import { useContext } from 'react';

import { Context } from '../components/Calculator';


function useCalculator() {
    return useContext(Context);
}

export default useCalculator;